module.exports = __webpack_public_path__ + "static/media/maintainment.9d240632.svg";